import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Card } from '@sravni/react-design-system/lib/Card';
import * as Grid from '@sravni/react-design-system/lib/Grid';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { Image } from '@/components/Image';

import { STEPS } from './constants';
import styles from './styles.module.scss';
import type { Step } from './types';

export const StepsBlock = () => {
  const isMobile = useIsMobile();

  return (
    <Grid.Row gutter={isMobile ? [8, 8] : [16, 16]} className={isMobile ? 'h-pt-16 h-pb-16' : 'h-pt-32 h-pb-32'}>
      {STEPS.map(({ id, title, image }: Step, idx: number) => (
        <Grid.Col key={id} span={isMobile ? 6 : 3} className={styles['card-wrapper']}>
          <Card size={16} color="dark" className={styles.card}>
            <Space direction="vertical" justify="space-between" size={16}>
              <Space direction="vertical" size={16}>
                <Badge color="dark" text={`шаг ${idx + 1}`} variant="primary" />
                <Heading level={5}>{title}</Heading>
              </Space>
              <Space justify="center">
                <Image alt="step-img" {...image} />
              </Space>
            </Space>
          </Card>
        </Grid.Col>
      ))}
    </Grid.Row>
  );
};
